/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  blue_10: '#e6eefc',
  blue_20: '#c2dbfc',
  blue_30: '#9dc2fa',
  blue_40: '#72a5f2',
  blue_50: '#4a89e8',
  blue_60: '#2e6fd9',
  blue_70: '#1f5dc2',
  blue_80: '#164ea8',
  blue_90: '#114091',
  blue_100: '#0f397d',

  a11y_text_light: [60, 70, 80, 90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/blue.js